module.exports = __webpack_public_path__ + "static/media/nc.4a81364a.svg";